import * as Constants from "utils/constants";

export function getLanguage() {
    var languageWithoutRegionCode = navigator.language.split('-')[0];
    switch (languageWithoutRegionCode) {
        case "en": return Constants.LANGUAGE.ENGLISH;
        case "es": return Constants.LANGUAGE.SPANISH;
        default: throw Error(`Unsupported language '${languageWithoutRegionCode}' provided.`);
    }
}

export function getQueryParam(name) {
    var queryString = window.location.search;
    if (queryString === "")
        queryString = window.location.hash.split('?')[1];
    var params = new URLSearchParams(queryString);
    var val = params.get(name);
    if (!val)
        return null;
    return val;
}